import { styled, Chip } from '@mui/material'
import { FieldProps, useRecordContext } from 'react-admin'
import { imageUrlConcat } from '../../../utils/url-concat'
import get from 'lodash/get'

const StatusChipContainer = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'end',
  transition: `opacity ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}`,
  '&:hover': {
    opacity: 0,
  },
}))

const ImgBackground = styled('div')(({ theme }) => ({
  backgroundPosition: 'center',
  backgroundColor: theme.palette.grey[300],
  backgroundSize: 'cover',
  height: 200,
  padding: 20,
  [theme.breakpoints.up('sm')]: {
    height: 250,
  },
}))

const StyledChip = styled(Chip)(({ theme }) => ({
  color: theme.palette.common.white,
  fontWeight: 600,
}))

// const ApprovedChip = <StyledChip label='Approved' sx={{ bgcolor: 'primary.main' }} />
const PublishChip = <StyledChip label='Published' sx={{ bgcolor: 'success.main' }} />
const DraftChip = <StyledChip label='Draft' sx={{ bgcolor: 'info.main' }} />
const HightLightChip = <StyledChip label='Hightligh' sx={{ bgcolor: 'primary.main' }} />

export const NewsImgHeader: React.FC<FieldProps> = ({ source }) => {
  const record = useRecordContext()
  const imgUrl = imageUrlConcat(get(record, source))
  // const isApprove = record.is_approved && !record.is_published
  const isPublished = record.is_published && record.is_approved
  // const isDrafting = !isApprove && !isPublished
  const isDrafting = !isPublished
  const isHighLight = record.is_highlight
  return source ? (
    <ImgBackground sx={{ backgroundImage: `url(${imgUrl})` }}>
      <StatusChipContainer>
        {/* {isApprove && ApprovedChip} */}
        {isPublished && PublishChip}
        {isDrafting && DraftChip}
        {isHighLight && HightLightChip}
      </StatusChipContainer>
    </ImgBackground>
  ) : null
}
